export default function TextIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M5 4v3h5.5v12h3V7H19V4H5z" />
		</svg>
	)
}
